import type { ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import classes from './AuthLayout.module.css';
import { FmcCredit } from './FmcCredit';

/**
 * Anonymous surface (login, tenant selection, password recovery): the product's own panel on the
 * left, the tenant-neutral stage on the right and the provider's credit in the corner.
 */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { t } = useTranslation('auth');

  return (
    <div className={classes.root}>
      <aside className={classes.panel}>
        <div>
          <div className={classes.wordmark}>
            Service<span>Ledger</span>
          </div>
          <p className={classes.tagline}>{t('brand.tagline')}</p>
        </div>
        <div className={classes.locale}>{t('brand.locale')}</div>
      </aside>
      <main className={classes.stage}>
        {children}
        <div className={classes.credit}>
          <FmcCredit />
        </div>
      </main>
    </div>
  );
}
